var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B0714309-9020-43C6-B860-460F8A4AE12D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -642.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-3",
    transform: "translate(0.000000, 532.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gear",
    transform: "translate(22.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.35,6.225 C13.2,5.55 12.9,4.875 12.525,4.275 L13.275,2.7 L12.225,1.65 L10.65,2.4 C10.05,2.025 9.45,1.8 8.775,1.65 L8.25,0 L6.75,0 L6.15,1.65 C5.475,1.8 4.875,2.1 4.275,2.475 L2.7,1.725 L1.65,2.7 L2.4,4.275 C2.025,4.875 1.8,5.475 1.65,6.15 L0,6.75 L0,8.25 L1.65,8.85 C1.8,9.525 2.1,10.2 2.4,10.725 L1.65,12.3 L2.7,13.35 L4.275,12.6 C4.875,12.975 5.475,13.275 6.15,13.425 L6.75,15 L8.25,15 L8.85,13.35 C9.075,13.275 9.375,13.2 9.6,13.125 L8.4,11.925 C5.55,12.45 3,10.35 3,7.5 C3,5.025 5.025,3 7.5,3 C10.275,3 12.375,5.475 11.925,8.1 L13.2,9.375 C13.275,9.15 13.35,9 13.35,8.775 L15,8.25 L15,6.75 L13.35,6.225 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7391458,13.1915624 L10.5034916,9.00733413 C11.5085621,6.80884132 9.42663038,4.46851027 7.1293264,5.10678238 L8.42155989,6.38332659 C8.99588589,6.95067957 8.99588589,7.87262816 8.42155989,8.36906202 C7.91902464,8.936415 6.91395415,8.936415 6.41141891,8.36906202 L5.11918542,7.16343694 C4.47306868,9.14917237 6.55500041,11.4185843 8.92409514,10.4966357 L13.1597493,14.6808639 C13.5904938,15.1063787 14.2366106,15.1063787 14.6673551,14.6808639 C15.0980996,14.3262683 15.0980996,13.6170771 14.7391458,13.1915624 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.ed6ed4cbfe926657041930708672ef1a.svg";
export { ForwardRef as ReactComponent };